export const SET_DATA = "project/SET_DATA";
export const SET_PROJECT_LIST = "project/SET_PROJECT_LIST";
export const SET_PROJECTS_LIST_ONLY = "project/SET_PROJECTS_LIST_ONLY";
export const RESET = "project/RESET";
